import React from "react";
import { Skeleton, Stack } from "@mui/material";

const WheelTableSkeletonLoader = ({ count = 4 }) => {
  return (
    <Stack gap={1}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={"100%"}
          height={110}
          sx={{ borderRadius: "8px" }}
        />
      ))}
    </Stack>
  );
};

export default WheelTableSkeletonLoader;
